export enum GroundingRenderStep {
  GRD_ENTER_VIN = 0,
  GRD_OPTIONS = 1,
  GRD_TURN_IN = 2,
  GRD_RESULT = 3
}
